import { render, staticRenderFns } from "./chatLog.vue?vue&type=template&id=267a73c0&"
import script from "./chatLog.vue?vue&type=script&lang=js&"
export * from "./chatLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports